(function () {
  var GLASSWARE_HANDLES = ['1-litre-amber-glass-bottle-usa-manufactured','500ml-amber-glass-bottle','300ml-amber-glass-tulip-bottle','250ml-amber-glass-midi-bottle','250ml-amber-glass-bottle','100ml-amber-glass-bottle','50ml-amber-glass-bottle','test-amber-glass-bottle','100ml-amber-glass-bottle-with-gold-fine-mist-spray','100ml-amber-glass-bottle-with-silver-fine-mist-spray','50ml-amber-glass-bottle-with-gold-fine-mist-spray','50ml-amber-glass-bottle-with-silver-fine-mist-spray','30ml-amber-glass-bottle-with-gold-fine-mist-spray','30ml-amber-glass-bottle-with-silver-fine-mist-spray','15ml-amber-glass-roller-bottle-with-walnut-lid','250ml-amber-glass-foaming-soap-dispenser-with-chrome-pump','250ml-amber-glass-foaming-soap-dispenser-with-copper-pump','250ml-amber-glass-foaming-soap-dispenser-with-rose-gold-pump','250ml-amber-glass-foaming-soap-dispenser-with-matt-black-pump','250ml-amber-glass-foaming-soap-dispenser-with-brass-pump','250ml-amber-glass-foaming-soap-dispenser-with-brushed-stainless-steel-pump','500ml-amber-glass-boston-soap-dispenser-with-rose-gold-pump','500ml-amber-glass-boston-soap-dispenser-with-chrome-pump','500ml-amber-glass-boston-soap-dispenser-with-copper-pump','500ml-amber-glass-boston-soap-dispenser-with-matt-black-pump','500ml-amber-glass-boston-soap-dispenser-brushed-stainless-steel-pump','500ml-amber-glass-boston-soap-dispenser-with-brass-pump','250ml-amber-glass-midi-bottle-dispenser-with-matt-black-pump','250ml-amber-glass-midi-bottle-dispenser-with-chrome-pump','250ml-amber-glass-midi-bottle-dispenser-with-rose-gold-pump','250ml-amber-glass-midi-bottle-dispenser-with-brushed-stainless-steel-pump','250ml-amber-glass-midi-bottle-dispenser-with-copper-pump','250ml-amber-glass-midi-bottle-dispenser-with-brass-pump','250ml-amber-glass-midi-spray-bottle-with-bpa-free-trigger-spray','30ml-amber-glass-bottle-with-black-fine-mist-spray','30ml-amber-glass-bottle-with-black-lotion-gel-pump-bpa-free','100ml-amber-glass-bottle-with-black-fine-mist-spray','100ml-amber-glass-bottle-with-black-lotion-gel-pump','50ml-amber-glass-bottle-with-black-lotion-gel-pump-bpa-free','50ml-amber-glass-bottle-with-black-fine-mist-spray-bpa-free','500ml-amber-glass-spray-bottle-with-bpa-free-trigger-spray','500ml-amber-glass-jar','175ml-amber-glass-jar','120ml-amber-glass-jar-cap','60ml-amber-glass-jar-cap','50ml-amber-glass-jar-cap','300ml-amber-glass-tulip-soap-dispenser-black','300ml-amber-glass-tulip-soap-dispenser-with-chrome-pump','300ml-amber-glass-tulip-soap-dispenser-with-brass-pump','300ml-amber-glass-tulip-soap-dispenser-with-rose-gold-pump','300ml-amber-glass-tulip-soap-dispenser-with-copper-pump','300ml-amber-glass-tulip-soap-dispenser-with-brushed-stainless-steel-pump'];
  var DECALS_URL = '/collections/decals-labels';
  var bannerEl = null;

  function hasGlassware(cart) {
    if (!cart || !cart.items) return false;
    for (var i = 0; i < cart.items.length; i++) {
      if (GLASSWARE_HANDLES.indexOf(cart.items[i].handle) !== -1) return true;
    }
    return false;
  }

  function findAnchor() {
    var drawer = document.querySelector('cart-drawer, .cart-drawer');
    if (!drawer) return null;
    var bar = drawer.querySelector('.free-shipping-bar');
    if (bar) return { ref: bar, position: 'afterend' };
    var inner = drawer.querySelector('.cart-drawer-inner');
    if (inner) return { ref: inner, position: 'beforebegin' };
    return null;
  }

  function hideBanner() {
    if (bannerEl) {
      bannerEl.remove();
      bannerEl = null;
    }
  }

  function buildBanner() {
    var el = document.createElement('div');
    el.setAttribute('role', 'status');
    el.className = 'glassware-decal-callout';
    el.style.cssText = 'display:flex;align-items:center;gap:10px;background:var(--color-background-2,#f5f5f0);color:var(--color-text,#1d1d1f);border-radius:10px;padding:12px 14px;margin:0 0 16px;font-size:13px;line-height:1.4;font-family:var(--body-font-family,inherit);';
    var textEl = document.createElement('span');
    textEl.style.cssText = 'flex:1;';
    textEl.textContent = 'Your jar or bottle qualifies for 50% off a decal — add one before checkout.';
    var linkEl = document.createElement('a');
    linkEl.href = DECALS_URL;
    linkEl.textContent = 'Shop decals';
    linkEl.style.cssText = 'flex-shrink:0;background:var(--btn-primary-bg-color,#1d1d1f);color:var(--btn-primary-color,#fff);padding:7px 12px;border-radius:8px;text-decoration:none;font-weight:500;white-space:nowrap;font-size:13px;';
    el.appendChild(textEl);
    el.appendChild(linkEl);
    return el;
  }

  function showBanner() {
    if (bannerEl && bannerEl.isConnected) return;
    bannerEl = null;
    var anchor = findAnchor();
    if (!anchor) return;
    var el = buildBanner();
    anchor.ref.insertAdjacentElement(anchor.position, el);
    bannerEl = el;
  }

  function evaluateCart(cart) {
    if (hasGlassware(cart)) {
      showBanner();
    } else {
      hideBanner();
    }
  }

  function fetchCart() {
    fetch('/cart.js', { headers: { accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(evaluateCart)
      .catch(function () {});
  }

  var origFetch = window.fetch;
  window.fetch = function () {
    var args = arguments;
    var urlArg = args[0];
    var url = urlArg && urlArg.url ? urlArg.url : urlArg;
    var isCartMutation = typeof url === 'string' && /\/cart\/(add|change|update|clear)(\.js)?/.test(url);
    return origFetch.apply(this, args).then(function (response) {
      if (isCartMutation) {
        response.clone().json().then(function (data) {
          if (data && data.items) {
            setTimeout(function () { evaluateCart(data); }, 50);
          } else {
            setTimeout(fetchCart, 50);
          }
        }).catch(function () { setTimeout(fetchCart, 50); });
      }
      return response;
    });
  };

  var observer = new MutationObserver(function () {
    if (bannerEl && !bannerEl.isConnected) {
      bannerEl = null;
      fetchCart();
    }
  });
  observer.observe(document.body, { childList: true, subtree: true });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', fetchCart);
  } else {
    fetchCart();
  }
})();
